var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selected)?_c('core-list-expand-section',{staticClass:"expansions"},_vm._l((_vm.contained),function(subitem){return _c('app-game-item',{key:subitem.id,attrs:{"filter":"collection","summarised":true,"item":subitem,"fields":_vm.columns,"noactions":true}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }